<template>
    <router-view></router-view>
  <img v-show="false" :src="gifUrl" alt="">
</template>
<script setup>
import {onBeforeUnmount, provide, ref} from "vue";
// 将 Blob 转换为 Base64
 function convertBlobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
const gifUrl = ref('')
let timer = null
const fetchGif = () => {
  timer = setTimeout(()=>{
    gifUrl.value = 'https://oss.shudaozaixian.com/assets/pc/ai_loading.gif';
   },4000)

}
onBeforeUnmount(()=>{
  if (timer){
    clearTimeout(timer)
  }
})
fetchGif()
provide('gifUrl', ()=>gifUrl.value)
function adjustForScaling() {
  // 判断是否为 PC 终端
  const isPC = () => {
    return /Win|Mac|Linux/.test(navigator.platform);
  };

  // 获取桌面缩放比例
  const getScaleFactor = () => {
    return window.devicePixelRatio || 1; // 默认比例为 1
  };
  // 判断屏幕分辨率
  const isHighResolution = () => {
    return window.screen.width > 1920 || window.screen.height > 1080; // 根据宽高判断
  };
  // 还原缩放
  const restoreScaling = () => {
    if (isPC()) {
      const scaleFactor = getScaleFactor();
      if (scaleFactor > 1 && typeof document.body.style.zoom !== 'undefined') { // 仅当缩放比例大于 100% 时才还原
        const zoomFactor = isHighResolution() ? 1.5 : 1.25; // 根据分辨率选择缩放因子
        document.body.style.zoom = `${(1 / scaleFactor) * zoomFactor}`; // 使用 zoom 属性
      }
    }
  };

  // 执行还原缩放
  restoreScaling();
}
// adjustForScaling()
</script>